import type { ErrorType } from '~/data/ErrorRecord';

export const defaultState: Fields = {
  isLoading: false,
  isModalOpen: false,
  isMachineDeleted: false,
  machineId: '',
  machineName: '',
  machineTags: [],
  error: undefined,
};

export interface Fields {
  isLoading: boolean;
  isModalOpen: boolean;
  isMachineDeleted: boolean;
  machineId: string;
  machineName: string;
  machineTags: string[];
  error?: ErrorType;
}
